import * as React from 'react';
import styled from 'styled-components';
import * as Icon from '../../icons';
import { Styledes, Closeable } from './types';

export interface Props extends Styledes, Closeable {}

export const CloseWrapper = styled.div`
    padding-left: 30px;
    padding-top: 1em;
    padding-bottom: 1em;
`;

export const Close = styled.button`
    background-color: #7f7b9b;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    line-height: 0;
    position: relative;
    transition: all .33s ease-in-out;
    border: 0;

    & > svg {
        fill: #fbfbfd;
        position: absolute;
        top: 50%;
        left: 50%;
        width: calc(100% - 8px);
        height: calc(100% - 8px);
        transform: translate(-50%, -50%);
    }

    &:hover {
        box-shadow: 0px 5px 7px rgba(0, 0, 0, 0.35);
    }
`;

export default React.memo(({ handleClose, className }: Props) => {
    return (
        <CloseWrapper>
            <Close onClick={handleClose} className={className}>
                <Icon.Close />
            </Close>
        </CloseWrapper>
    );
});
